import React, { useEffect, useState, useContext } from 'react';
import NavBar from '../Components/Main/NavBar';
import Footer from '../Components/Main/Footer';
import '../css/Item/Item.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import LoadingIcons from 'react-loading-icons';
import { CartContext } from '../Context/CartProvider';
import ProductGallery from '../Components/Item/ProductGallery';
import { AuthContext } from '../Context/AuthProvider';

const Item = () => {
    const { user } = useContext(AuthContext);
    const { addToCart } = useContext(CartContext);
    const location = useLocation();
    const { type } = location.state || {};
    const { category, subcategory, id } = useParams();

    const [product, setProduct] = useState(null);
    const [selectedColor, setSelectedColor] = useState();
    const [descriptionType, setDescriptionType] = useState("leiras");
    const [quantity, setQuantity] = useState(1);

    const [ShortDesc, setShortDesc] = useState("");
    const [MediumDesc, setMediumDesc] = useState("");
    const [SpecsDesc, setSpecsDesc] = useState("");

    const navigate=useNavigate();

    useEffect(() => {
        const API = process.env.REACT_APP_BACKEND_URL;

        const fetchProduct = async () => {
            try {
                const params = {
                    id,
                    ...(user?.id && { account_id: user.id })
                };

                let apiRoute = '/wproduct';
                if (type === 'machine') {
                    apiRoute = '/machine';
                }

                const response = await axios.get(`${API}${apiRoute}`, { params });
                const rawProduct = response.data[0];
                if (!rawProduct) return;

                // 🔥 Normalize machine data
                if (type === 'machine') {
                    const normalizedProduct = {
                        id: rawProduct.id,
                        name: rawProduct.name,
                        image: rawProduct.image,
                        category: { name: rawProduct.category?.name},
                        subcategory: { name: rawProduct.subcategory.name },
                        stock: 1,
                        price: 0,
                        wholePrice: 0,
                        discount_percentage: 0,
                        colors: [],
                        descriptions: {
                            short: rawProduct.descriptions.short,
                            medium: rawProduct.descriptions.medium,
                            specs: rawProduct.descriptions.specs
                        }
                    };

                    setProduct(normalizedProduct);
                } else {
                    // material stays original
                    setProduct(rawProduct);

                    setShortDesc(rawProduct.descriptions?.short?.replace(/\\n/g, '\n') || "");
                    setMediumDesc(rawProduct.descriptions?.medium?.replace(/\\n/g, '\n') || "");
                    setSpecsDesc(rawProduct.descriptions?.specs?.replace(/\\n/g, '\n') || "");

                    if (rawProduct.colors?.length > 0) {
                        setSelectedColor(rawProduct.colors[0].name);
                    }
                }

            } catch (error) {
                console.log(error);
            }
        };

        fetchProduct();
    }, [id, user, type]);

    const handleCart = (e) => {
        e.stopPropagation();

        if (!product) return;

        const cartItem = {
            id: Number(product.id),
            item: product.name,
            image: product.image,
            color: selectedColor || null,
            price: Number(product.price)
        };

        addToCart(cartItem, Number(quantity));
    };

    const handleChange = (event) => {
        setSelectedColor(event.target.value);
    };

    return (
        <div className='item-container'>
            <NavBar />

            {product ? (
                <div>
                    <div className='item-upper-container'>
                        <div className='item-image-container'>
                            <ProductGallery product={product} />
                        </div>

                        <div className='item-info-container'>
                            <p>
                                {product.category?.name} -- {product.subcategory?.name}
                            </p>

                            <h1>{product.name}</h1>

                            {type !== 'machine' && (
                                <>
                                    <p className={product.stock === 1 ? "product-card-stock" : "product-card-stock-none"}>
                                        {product.stock === 1 ? "Raktáron" : "Nincs Raktáron"}
                                    </p>

                                    {!user && product.discount_percentage > 0 && (
                                        <p className='wholeprice'>
                                            {Number(product.wholePrice).toLocaleString('hu-HU', {
                                                style: 'currency',
                                                currency: 'HUF'
                                            })}
                                        </p>
                                    )}

                                    {product.price > 0 ? (
                                        <h3>
                                            {Number(product.price).toLocaleString('hu-HU', {
                                                style: 'currency',
                                                currency: 'HUF'
                                            })}
                                        </h3>
                                    ) : (
                                        <h3>Hamarosan elérhető</h3>
                                    )}

                                    {product.price > 0 && <p>(Áfát tartalmaz)</p>}

                                    {product.colors?.length > 0 && (
                                        <select
                                            id="color"
                                            value={selectedColor}
                                            onChange={handleChange}
                                        >
                                            {product.colors.map((color, index) => (
                                                <option key={index} value={color.name}>
                                                    {color.name}
                                                </option>
                                            ))}
                                        </select>
                                    )}

                                    <label>Mennyiség: </label>
                                    <input
                                        type="number"
                                        min={1}
                                        max={20}
                                        value={quantity}
                                        onChange={(e) => setQuantity(e.target.value)}
                                    />
                                    {product.price === 0 ? 
                                        (<button onClick={() => navigate('/kapcsolat', { state: { product_name: product.name }})}>Ajánlatkérés</button>)
                                    
                                    : (<button onClick={handleCart}>Kosárba</button>)}
                                    
                                </>
                            )}
                            {type === 'machine' && (
                                <button onClick={() => navigate('/kapcsolat', { state: { product_name: product.name }})}>Ajánlatkérés</button>
                                )}
                        </div>
                    </div>
                    {type === 'machine' && (
                        <div className='item-lower-container'>
                            <div className='item-lower-short'>
                                <h2>Rövid Leírás</h2>
                                <p>{product.descriptions?.medium}</p>
                            </div>
                        </div>
                    )}
                    {type !== 'machine' && (
                        <div className='item-lower-container'>
                            <div className='item-lower-short'>
                                <h2>Rövid Leírás</h2>
                                <p>{ShortDesc}</p>
                            </div>

                            <div className='item-lower-buttons'>
                                <button
                                    onClick={() => setDescriptionType("leiras")}
                                    className={descriptionType === "leiras" ? 'active' : 'inactive'}
                                >
                                    Leírás
                                </button>

                                <button
                                    onClick={() => setDescriptionType("spec")}
                                    className={descriptionType === "spec" ? 'active' : 'inactive'}
                                >
                                    Specifikációk
                                </button>
                            </div>

                            <div className='item-lower-desc'>
                                <p>
                                    {descriptionType === "leiras" && MediumDesc}
                                    {descriptionType === "spec" && SpecsDesc}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div>
                    <h1><LoadingIcons.Bars /></h1>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default Item;
